var randomize = require('randomatic');

export const nameSpaceGenrator = () => randomize('0', 6);

export const titleCase = (str) => {
    let titleCaseString = str.split('-').map(w => w[0].toUpperCase() + w.slice(1)).join(' ')
    return titleCaseString
}
